<script lang="ts">
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let benefit: string;
</script>

<span class="lg:text-2md bg-white px-4 py-1 text-[1.125rem] font-bold leading-[1.43]">{nbspify(benefit)}</span>
